import { useEffect, useState } from "react";
import {
  ChartData,
  ChartDataParams,
  FormatChartData,
} from "./recharts/functions";
import FilterMenu from "./FilterMenu";
import { ReMixChart } from "./recharts/ReMixCharts";
import { ChartType } from "../models/chart_model";
import { ExchangeColors } from "../pages/Dashboard/Exchange3/FormatData";
import { InsightTabProps } from "../models/insight_tab";

export const VOL_UNITS = ["MW", "MWh", "LU"];

export function InsightTab({ insightTab }: { insightTab: InsightTabProps }) {
  const [formateData, setFormateData] = useState<ChartData>({
    data: [],
    keys: [],
    unit_keys: [],
    keysLabels: [],
    group_by: {},
  });
  const [selectedXAxis, setSelectedXAxis] = useState(insightTab.keys.xAxis[0]);
  const [selectedGroupBy, setSelectedGroupBy] = useState(
    insightTab.keys.groupBy[0]
  );
  const [selectedUnit, setSelectedUnit] = useState(VOL_UNITS[0]);
  const [extraFilterData, setExtraFilterData] = useState<any[]>([]);
  const [selectedExtraFilters, setSelectedExtraFilters] = useState<string[]>(
    []
  );
  const [selectedChartTypes, setSelectedChartTypes] = useState<ChartType[]>([
    ChartType.Bar,
    ChartType.Line,
  ]);

  useEffect(() => {
    insightTab.data = insightTab.data.map((item) => {
      const computed = [
        insightTab.keys.vol_mw,
        ...(insightTab.keys.extra_vol_mw || []),
      ].reduce((acc, key) => {
        const value = item[key as string] || 0;
        acc[`${key}_mw`] = value;
        acc[`${key}_mwh`] = value / 4;
        acc[`${key}_lu`] = value / 400;
        return acc;
      }, {} as Record<string, number>);

      return {
        ...item,
        ...computed,
      };
    });
    // console.log(insightTab.data);
    const uniqueData =
      insightTab.filters.extraFilters?.map((item) => {
        return {
          [item.key]: [
            ...new Set(insightTab.data.map((item) => item[item.key])),
          ],
        };
      }) || [];
    setExtraFilterData(uniqueData);
  }, [insightTab]);
  useEffect(() => {
    const chartPar: ChartDataParams = {
      data: insightTab.data,
      keys: selectedXAxis.keys,
      groupBy: selectedGroupBy.keys,
      aggregationKeys:
        insightTab.keys.extra_vol_mw?.map(
          (key) => key + "_" + selectedUnit.toLowerCase()
        ) || [],
      volumeKey:
        (insightTab.keys.vol_mw || "") + "_" + selectedUnit.toLowerCase(),
      priceKey: insightTab.keys.price_rs_kwh || "",
    };
    const cData = FormatChartData(chartPar);
    // console.log(cData);
    setFormateData(cData);
  }, [insightTab, selectedXAxis, selectedGroupBy, selectedUnit]);
  function handleUnitChange(params: string) {
    setSelectedUnit(params);
  }
  function handleXAxisChange(params: string) {
    setSelectedXAxis(
      insightTab.keys.xAxis.find((item) => item.label === params) ||
        insightTab.keys.xAxis[0]
    );
  }
  function handleGroupByChange(params: string) {
    setSelectedGroupBy(
      insightTab.keys.groupBy.find((item) => item.label === params) ||
        insightTab.keys.groupBy[0]
    );
  }
  function handleExtraFilterChange(params: string, index: number) {
    setSelectedExtraFilters([...selectedExtraFilters, params]);
  }

  return (
    <div className="gas-page-container">
      <div className="side-filters-container text-nowrap">
        <FilterMenu
          title="Unit"
          items={VOL_UNITS}
          selectedItems={[selectedUnit]}
          onSelect={(item, index) => handleUnitChange(item)}
        />
        {insightTab.filters.xAxis && (
          <FilterMenu
            title="X Axis"
            items={insightTab.keys.xAxis.map((item) => item.label)}
            selectedItems={[selectedXAxis.label]}
            onSelect={(item, index) => handleXAxisChange(item)}
          />
        )}
        {insightTab.filters.groupBy && (
          <FilterMenu
            title="Group By"
            items={insightTab.keys.groupBy.map((item) => item.label)}
            selectedItems={[selectedGroupBy.label]}
            onSelect={(item, index) => handleGroupByChange(item)}
          />
        )}
        {insightTab.filters.extraFilters &&
          insightTab.filters.extraFilters.map((item, index) => {
            return (
              <FilterMenu
                title={item.label}
                items={extraFilterData[index]}
                selectedItems={[selectedExtraFilters[index]]}
                onSelect={(item, index) => handleExtraFilterChange(item, index)}
              />
            );
          })}
      </div>
      <div className="gas-chart-container">
        <ReMixChart
          data={formateData?.data ?? []}
          xDataKey={selectedXAxis.keys[0]}
          showBrush={formateData.data.length > 0}
          fontSize={12}
          unit=""
          yAxisLabel={selectedUnit}
          secondYAxisLabel="Rs/kWh"
          legends={
            formateData?.keys.flatMap((item1, index) => {
              return formateData.unit_keys.flatMap((item, index) => {
                return {
                  dataKey: item1 + "_" + item,
                  type: selectedChartTypes[index],
                  yAxisId: index === 1 ? "right" : undefined,
                  unit: item,
                  name: item1 + " " + item,
                  stroke: ExchangeColors[index],
                };
              });
            }) || []
          }
        />
      </div>
    </div>
  );
}
